import { useQuery } from '@tanstack/solid-query'
import { getServiceClient, getUserServer } from '~/lib/api'
import { fetchSpecialChallengeConfig } from '~/lib/special-challenge-config'
import type { ActivityProgressesResponse } from '~/lib/special-challenge-model'

export * from '~/lib/special-challenge-model'

export const specialChallengeConfigKey = ['special-challenge-config'] as const

export const specialChallengeProgressKey = [
  'special-challenge-progress',
] as const

export function useSpecialChallengeConfigQuery() {
  return useQuery(() => ({
    queryKey: specialChallengeConfigKey,
    queryFn: async () => {
      const server = await getUserServer()
      return await fetchSpecialChallengeConfig(server)
    },
  }))
}

export function useSpecialChallengeProgressQuery(
  activityId: () => number | null,
) {
  return useQuery(() => ({
    queryKey: [...specialChallengeProgressKey, activityId()],
    enabled: activityId() != null,
    queryFn: async () => {
      const { client, userId } = await getServiceClient()
      // A single progress, no Plus track — no include_subscription_progress.
      return await client
        .get(`challenge/users/${userId}/progresses/activity/${activityId()}`)
        .json<ActivityProgressesResponse>()
    },
  }))
}
